export const BILLS_TYPE = 'bills'
export const MAKERS_TYPE = 'makers'

export const FILTER_ALL = {
  code: 'ALL',
  description: 'Всё, что есть',
}
